import template from "./template.html";
import config from "../config";

export default function (editor) {
  const { DomComponents, BlockManager } = editor;

  DomComponents.addType("features-succeed", {
    isComponent: (el: HTMLElement) => el.classList && el.classList.contains("features-succeed"),
    model: {
      defaults: {
        draggable: true,
        removable: true,
        selectable: true,
        hoverable: true,
      },
    },
  });

  BlockManager.add("features-succeed", {
    ...config,
    label: "Features to succeed",
    content: template,
  });
}
